import placeholder from "../assets/team/person.png"
import kurur_img from "../assets/team/kurur.jpeg"
import shilpi_img from "../assets/team/shilpi.png"
import puru_img from "../assets/team/puru.jpg"
import sumit_img from "../assets/team/sumit.jpg"
import gaurav_img from "../assets/team/gaurav.jpg"
import saksham_img from "../assets/team/saksham.jpeg"
import nirmal_img from "../assets/team/nirmal.jpg"

const team_members = {
    "faculty_head": [
        {
            "name": "Prof. Narayan Kurur",
            "role": "Dean, Academics",
            "image": kurur_img
        },
        {
            "name": "Prof. Shilpi Sharma",
            "role": "Associate Dean, Outreach and New Initiatives",
            "image": shilpi_img
        }
    ],
    "staff_members": [
        {
            "name": "Saksham",
            "role": "Staff Member, IIT Delhi",
            "image": saksham_img
        },
        {
            "name": "Gaurav",
            "role": "Staff Member, IIT Delhi",
            "image": gaurav_img
        },
        {
            "name": "Nirmal",
            "role": "Staff Member, IIT Delhi",
            "image": nirmal_img
        },
        {
            "name": "Ajay",
            "role": "Staff Member, IIT Delhi",
            "image": placeholder
        },
        {
            "name": "Abhinav",
            "role": "Staff Member, IIT Delhi",
            "image": placeholder
        },
        {
            "name": "Renu",
            "role": "Staff Member, IIT Delhi",
            "image": placeholder
        },
    ],
    "student_members": [
        {
            "vertical": "Secretaries",
            "members": [
                {
                    "name": "Sumit Kumar",
                    "role": "General Secretary, IIT Delhi",
                    "image": sumit_img
                },
                {
                    "name": "Pururaj Singh",
                    "role": "Deputy General Secretary, IIT Delhi",
                    "image": puru_img
                }
            ]
        },
        {
            "vertical": "Technical",
            "members": [
                {
                    "name": "Aman",
                    "role": "Technical Member, IIT Delhi",
                    "image": placeholder
                },
                {
                    "name": "Rahul",
                    "role": "Technical Member, IIT Delhi",
                    "image": placeholder
                },
                {
                    "name": "Raj",
                    "role": "Technical Member, IIT Delhi",
                    "image": placeholder
                }
            ]
        },
        {
            "vertical": "Design",
            "members": [
                {
                    "name": "Sakshi",
                    "role": "Design Member, IIT Delhi",
                    "image": placeholder
                },
                {
                    "name": "Riya",
                    "role": "Design Member, IIT Delhi",
                    "image": placeholder
                },
                {
                    "name": "Saksham",
                    "role": "Design Member, IIT Delhi",
                    "image": placeholder
                }
            ]
        },
        {
            "vertical": "Management",
            "members": [
                {
                    "name": "Aman",
                    "role": "Management Member, IIT Delhi",
                    "image": placeholder
                },
                {
                    "name": "Rahul",
                    "role": "Management Member, IIT Delhi",
                    "image": placeholder
                },
                {
                    "name": "Raj",
                    "role": "Management Member, IIT Delhi",
                    "image": placeholder
                }
            ]
        }
    ]
}

export default team_members;